import cls from 'classnames'

import { getMapComponent } from 'utils'
import { ReactComponent as HighQualityConnectionIcon } from 'assets/icons/HighQualityConnection.svg'
import { ReactComponent as MediumQualityConnectionIcon } from 'assets/icons/MediumQualityConnection.svg'
import { ReactComponent as LowQualityConnectionIcon } from 'assets/icons/LowQualityConnection.svg'

import { CallTimer } from '../CallTimer'
import { ECallConnectionQuality } from '../LiveKitRoom'

import styles from './CallStatus.module.scss'

export type TCallStatusProps = {
  isAnsweredCall: boolean
  startTime: Date | null | undefined

  connectionQuality?: ECallConnectionQuality
}

const CALL_STATUS_ICON = new Map<ECallConnectionQuality, (className: string) => JSX.Element>()
  .set(ECallConnectionQuality.GOOD, (className) => (
    <HighQualityConnectionIcon className={className} />
  ))
  .set(ECallConnectionQuality.MEDIUM, (className) => (
    <MediumQualityConnectionIcon className={className} />
  ))
  .set(ECallConnectionQuality.POOR, (className) => (
    <LowQualityConnectionIcon className={className} />
  ))

export const CallStatus = ({
  isAnsweredCall,
  startTime,
  connectionQuality = ECallConnectionQuality.GOOD
}: TCallStatusProps) => (
  <div className={styles.root}>
    {getMapComponent(
      CALL_STATUS_ICON,
      connectionQuality,
      cls({
        [styles.icon]: true,
        [styles.iconActive]: connectionQuality === ECallConnectionQuality.GOOD,
        [styles.iconInactive]: connectionQuality === ECallConnectionQuality.MEDIUM,
        [styles.iconInterrupted]: connectionQuality === ECallConnectionQuality.POOR
      })
    )}

    <CallTimer isAnsweredCall={isAnsweredCall} startTime={startTime} />
  </div>
)
